import { render, staticRenderFns } from "./sex-radio.vue?vue&type=template&id=2ba647fa&scoped=true&"
import script from "./sex-radio.vue?vue&type=script&lang=js&"
export * from "./sex-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba647fa",
  null
  
)

export default component.exports